import { NgModule } from '@angular/core';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { CommonModule } from 'app/common.module';

import { ButtonModule } from 'shared/components/button/button.module';
import { ComboButtonModule } from 'shared/components/combo-button/combo-button.module';

import { LogoutModalComponent } from './logout-modal.component';

@NgModule({
  imports: [ButtonModule, CommonModule, ComboButtonModule, DialogModule],
  exports: [LogoutModalComponent],
  declarations: [LogoutModalComponent],
  providers: [],
})
export class LogoutModalModule {}
